var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M14.2 15.5l-4.4 5.7 4.6 5.9M28.2 15.5l4.4 5.7-4.5 5.9M19 28.7l4.7-14.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M26.8 35.6H10c-3.2 0-5.7-2.6-5.7-5.7V14c0-3.2 2.6-5.7 5.7-5.7h22c3.2 0 5.7 2.6 5.7 5.7v16.3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 31.8,
    cy: 35.6,
    r: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuery);
export default __webpack_public_path__ + "static/media/query.c220a015215e60cf8e4b6633c0c98da4.svg";
export { ForwardRef as ReactComponent };